module.exports = __webpack_public_path__ + "img/App_Store_Badge.b27b2bcf.svg";